import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

interface FormModalProps {
  show: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
  // eslint-disable-next-line react/require-default-props
  size?: 'sm' | 'lg'
  // eslint-disable-next-line react/require-default-props
  enforceFocus?: boolean
  // eslint-disable-next-line react/require-default-props
  dialogClassName?: string
}

function FormModal({
  show,
  onClose,
  title,
  children,
  size = 'sm',
  enforceFocus = true,
  dialogClassName = 'modal',
}: FormModalProps) {
  const { t } = useTranslation()

  return (
    <Modal
      show={show}
      size={size}
      className="overflow-hidden"
      dialogClassName={dialogClassName}
      onHide={onClose}
      animation={false}
      backdropClassName="backdrop-with-modal"
      enforceFocus={enforceFocus}
      centered
    >
      <Modal.Header>
        <Modal.Title className="d-flex align-self-center">
          <h2>{title}</h2>
        </Modal.Title>
        <button
          type="button"
          className="btn btn-link no-underline btn-lg d-flex justify-content-center align-items-center px-0"
          onClick={onClose}
        >
          <span>{t('buttons.close')}</span>
          <i className="fal fa-times fa-2x ms-2" />
        </button>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
    </Modal>
  )
}

export default FormModal
